import { CircularProgress, MenuItem, TextFieldProps } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import FormInput from "./forminput";

type FormInputProps = TextFieldProps & {
  id: string;
  label: string;
  name: string;
};

function LanguageSelect(props: FormInputProps) {
  const { data = [], isLoading } = useQuery(
    ["languages"],
    async () => {
      const { data } = await axios.get("languages");
      return data as NnI[];
    },
    {
      staleTime: Infinity,
      refetchInterval: Infinity,
      refetchOnMount: false,
    }
  );

  return (
    <FormInput select {...props}>
      {isLoading && (
        <MenuItem value="" disabled>
          <CircularProgress size={20} />
        </MenuItem>
      )}
      {data.map((d) => (
        <MenuItem key={d.id} value={d.id}>
          {d.name}
        </MenuItem>
      ))}
    </FormInput>
  );
}

export default LanguageSelect;
